import {
  Component,
  OnInit,
  ViewEncapsulation,
  OnDestroy,
  ViewChild,
  ChangeDetectorRef,
} from "@angular/core";
import { AlertService } from "src/app/core/services/alert.service";
import { AuthenticationService } from "src/app/core/security/authentication.service";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { QueryEngineService } from "src/app/core/services/query-engine.service";
import { PageChangeEvent } from "@progress/kendo-angular-grid";
import { UntypedFormBuilder, FormGroup } from "@angular/forms";
import { BreadcrumbComponent } from "src/app/shared/bread-crumb/bread-crumb.component";

import { DynamicGridComponent } from "src/app/shared/dynamic-grid/dynamic-grid.component";
import { ReportDownloaderService } from "src/app/core/services/reportDownloader.service";

@Component({
  selector: "app-query-engine",
  templateUrl: "./query-engine.component.html",
  styleUrls: ["./query-engine.component.css"],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class QueryEngineComponent implements OnInit, OnDestroy {
  @ViewChild("dt") dt!: any;

  private queryEngineRequest: any;

  public loading = false;
  public isDownloadingQueryResult = false;
  queryList: any;
  userDefinedqueryList: any;
  selectedReportPack: any;
  selectedNodes: any[] = [];
  queryModel: any;
  userDefinedQueryModel: any;
  selectedQueryTypeId: number = 1;

  gridData: any;
  pageSize: number = 100;
  skip: number = 0;

  userQueryName: string = "";
  displaySaveQuerySection: boolean = false;
  reportPackResetToken: number = 0;

  redirectfromReport: boolean = false;

  reportTreeListData: any = [];
  treeList: any = [];
  headerCols: any[];
  reportingTypeOptions: any = [];
  selectedReportingTypes: any = ["Audit", "Exception"];
  private readonly defaultReportingTypes: string[] = ["Audit", "Exception"];
  enableSave: boolean = false;
  activeAccordionPanel: string | null = "0";
  allowAccordionToggle: boolean = false;

  constructor(
    private alertService: AlertService,
    private queryEngineService: QueryEngineService,
    private router: Router,
    private authService: AuthenticationService,
    private modalService: NgbModal,
    private formBuilder: UntypedFormBuilder,
    private downloaderService: ReportDownloaderService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    document.body.classList.add("query-engine-no-bg");

    if (!this.authService.isPrivacyNoticeAcknowledged) {
      this.router.navigate(["/privacy-notice"]);
    }

    this.queryEngineRequest = history.state?.queryEngineRequest;

    const newState = { ...(history.state || {}), queryEngineRequest: null };
    history.replaceState(newState, document.title, window.location.href);

    this.headerCols = [
      { field: "DisplayName", header: "Name" },
      { field: "Description", header: "Description" },
      { field: "ReportingType", header: "Reporting Type" },
      { field: "TemplateName", header: "Template Name" },
      { field: "", header: "Actions" },
    ];

    this.queryModel = {
      queryTypeId: 1,
      queryId: "",
      queryDisplayName: "",
      description: "",
      reportPackId: 0,
      reportPackTitle: "",
      pageNumber: 1,
      pageSize: this.pageSize,
      isInitialLoad: true,
      sortList: [],
      filter: [],
      auditReportDetailDesc: "",
      userDefinedQueryTypeId: 0,
      userDefinedQueryDisplayName: "",
      userDefinedQueryDescription: "",
      selectedGridDetails: "",
      selectedGridDetailDescription: "",
    };

    this.applyQueryEngineRequest();
    this.getQueryList();
  }

  ngOnDestroy() {
    document.body.classList.remove("query-engine-no-bg");
    this.modalService.dismissAll();
  }

  private getQueryList() {
    this.loading = true;
    this.queryEngineService
      .getQueryList()
      .then((queryList: any[]) => {
        this.queryList = queryList.map((x) => ({
          queryId: x.QueryId,
          displayName: x.QueryName,
          description: x.Description || x.QueryDescription || "",
        }));
        this.queryModel.queryId = this.queryList[0].queryId;
        this.queryModel.queryDisplayName = this.queryList[0].displayName;
        this.queryModel.description = this.queryList[0].description;
        this.loading = false;
        this.cdr.detectChanges();
      })
      .catch(() => {
        this.loading = false;
        this.cdr.detectChanges();
      });
  }

  onReportPackSelection() {
    const selectedReportPack = this.normalizeSelectedReportPack(
      this.selectedReportPack,
    );

    if (selectedReportPack) {
      this.selectedReportPack = selectedReportPack;
      this.queryModel.reportPackId = selectedReportPack.ReportPackID;
      this.queryModel.reportPackTitle = selectedReportPack.Title;
      var queryDisplayName = this.queryList?.filter(
        (x) => x.queryId == this.queryModel.queryId,
      )[0]?.displayName;
      this.queryModel.queryDisplayName =
        this.queryModel.reportPackId + "-" + queryDisplayName;
      if (
        this.queryModel.queryTypeId == 1 ||
        this.userDefinedQueryModel?.queryTypeId == 1
      )
        this.getReportDownloaderTreeList();
    } else this.queryModel.reportPackId = 0;
  }

  getQueryResult(isInitialLoad: boolean, applySelection: boolean) {
    this.loading = true;
    this.queryModel.pageNumber = this.skip / this.pageSize + 1;
    this.queryModel.isInitialLoad = isInitialLoad;
    if (
      this.userDefinedQueryModel != undefined &&
      this.userDefinedQueryModel.queryTypeId != null
    )
      this.queryModel.queryTypeId = this.userDefinedQueryModel.queryTypeId;

    if (!applySelection) {
      this.queryModel.filter = [];
      this.queryModel.sortList = [];
      this.queryModel.pageNumber = 1;
    }

    if (this.queryModel.queryId === null) {
      this.alertService.error("Please select a query!");
      return;
    }
    // else
    //   this.queryModel.queryDisplayName = this.queryList.filter(
    //     (x) => x.queryId == this.queryModel.queryId,
    //   )[0].displayName;
    if (
      this.queryModel.reportPackId === null ||
      this.queryModel.reportPackId == 0
    ) {
      this.alertService.error("Please select a report pack!");
      return;
    }
    this.loading = true;
    this.queryEngineService
      .getQueryResult(this.queryModel)
      .then((queryResult: any) => {
        this.gridData = {
          data: queryResult.Data,
          total: queryResult.TotalCount,
          columns: queryResult.Columns,
        };
        this.setselectedGridDetails();
        this.displaySaveQuerySection = true;
        this.enableSave =
          this.userDefinedQueryModel?.userDefinedQueryDisplayName == null;
        this.activeAccordionPanel = "1";
        this.allowAccordionToggle = true;
        this.loading = false;
        this.cdr.detectChanges();
      })
      .catch(() => {
        this.loading = false;
        this.cdr.detectChanges();
      });
  }

  setselectedGridDetails() {
    if (this.queryModel.queryTypeId == 1) {
      var splitDesc = this.queryModel.auditReportDetailDesc.split("~");
      this.queryModel.selectedGridDetails =
        splitDesc[0] + " - " + splitDesc[2] + " - " + splitDesc[5];
    } else {
      this.queryModel.selectedGridDetails = this.queryModel.queryDisplayName;
      this.queryModel.selectedGridDetailDescription =
        this.queryModel.description;
    }
  }

  pageChange(event: PageChangeEvent) {
    this.skip = event.skip;
    this.getQueryResult(false, true);
  }

  downloadQueryResult(dynamicModel: any) {
    if (this.isDownloadingQueryResult) {
      this.alertService.info(
        "A download is already in progress. Please wait.",
      );
      return;
    }

    this.skip = dynamicModel.skip;
    this.queryModel.isInitialLoad = false;
    // this.queryModel.sortList = dynamicModel.pageNumber;
    this.queryModel.sortList = dynamicModel.sortList;
    this.queryModel.filter = dynamicModel.filter;

    if (this.queryModel.queryTypeId == 1) {
      var splitDesc = this.queryModel.auditReportDetailDesc.split("~");
      this.queryModel.queryDisplayName =
        splitDesc[0] + "-" + splitDesc[2] + "-" + splitDesc[5];
    }

    this.isDownloadingQueryResult = true;
    this.alertService.info(
      "The query result download has started in the background.",
    );

    this.queryEngineService
      .downloadQueryResult(this.queryModel)
      .then(() => {
        this.alertService.success(
          "Query result downloaded successfully.",
        );
      })
      .catch(() => {
        this.alertService.error(
          "Failed to download query result. Please try again.",
        );
      })
      .finally(() => {
        this.isDownloadingQueryResult = false;
      });
  }

  updateQueryModel(dynamicModel) {
    const hasSortChanged =
      JSON.stringify(this.queryModel.sortList || []) !==
      JSON.stringify(dynamicModel.sortList || []);
    const hasFilterChanged =
      JSON.stringify(this.queryModel.filter || []) !==
      JSON.stringify(dynamicModel.filter || []);

    this.skip = dynamicModel.skip;
    this.queryModel.isInitialLoad = false;
    this.queryModel.sortList = dynamicModel.sortList;
    this.queryModel.filter = dynamicModel.filter;

    if (hasSortChanged || hasFilterChanged) {
      this.enableSave = true;
    }

    this.getQueryResult(false, true);
  }

  private clearGridData() {
    this.gridData = {
      data: [],
      total: 0,
      columns: [],
    };
    this.displaySaveQuerySection = false;
    this.userQueryName = "";
    this.selectedQueryTypeId = 0;
    this.skip = 0;
    this.queryModel.filter = [];
    this.queryModel.sortList = [];
    this.queryModel.reportPackId = 0;
    this.queryModel.reportPackTitle = "";
    this.queryModel.auditReportDetailDesc = "";
    this.queryModel.queryDisplayName = "";
    this.selectedReportPack = null;
    this.reportTreeListData = [];
    this.reportPackResetToken++;
    this.enableSave = false;
    this.allowAccordionToggle = false;
  }

  onTemplateTypeChange() {
    this.clearGridData();
    if (this.queryModel.queryId && this.queryList) {
      const selectedQuery = this.queryList.find(
        (x) => x.queryId == this.queryModel.queryId,
      );
      if (selectedQuery && this.queryModel.queryTypeId != 1) {
        this.queryModel.queryDisplayName = selectedQuery.displayName;
        this.queryModel.description = selectedQuery.description;
      }
    }
  }

  onQueryTypeChange() {
    this.clearGridData();
    this.selectedQueryTypeId = this.queryModel.queryTypeId;
    this.queryModel.userDefinedQueryTypeId = 0;
    this.queryModel.auditReportDetailDesc = "";
    this.userDefinedQueryModel = undefined;
    this.queryModel.queryDisplayName = this.queryList[0].displayName;
    if (this.queryModel.queryTypeId == 2) {
      this.getUserDefinedQueryList();
    }
  }

  private getReportDownloaderTreeList() {
    this.loading = true;
    this.downloaderService
      .getReportTreeList(this.selectedReportPack.ReportPackID)
      .then((reportList: any) => {
        this.treeList = JSON.parse(JSON.stringify(reportList));
        this.reportTreeListData = JSON.parse(JSON.stringify(reportList));
        const reportTemplateId =
          this.queryEngineRequest?.reportTemplateList?.ReportTemplateId;
        const reportDisplayName =
          this.queryEngineRequest?.reportDisplayName;

        if (reportTemplateId) {
          this.reportTreeListData = this.filterReportTreeById(
            this.treeList,
            reportTemplateId,
            reportDisplayName,
          );
          this.queryEngineRequest = null;
        }

        if (this.reportTreeListData.length > 0) {
          if (
            this.downloaderService.reportingTypes &&
            this.downloaderService.reportingTypes.length > 0
          ) {
            this.prepareReportingTypeOptions(
              this.downloaderService.reportingTypes,
            );
          } else {
            this.downloaderService
              .getReportingTypes()
              .then((reportingTypesList: any) => {
                this.prepareReportingTypeOptions(reportingTypesList);
              });
          }
        }
        if (!this.redirectfromReport) { this.loading = false; this.cdr.detectChanges(); }
      })
      .catch(() => {
        this.loading = false;
        this.cdr.detectChanges();
      });
  }

  private applyQueryEngineRequest() {
    if (!this.queryEngineRequest) {
      return;
    }
    this.loading = true;
    this.redirectfromReport = true;
    this.queryModel.queryTypeId = this.queryEngineRequest.queryTypeId || 1;
    this.selectedQueryTypeId = this.queryModel.queryTypeId;
    this.queryModel.reportPackId = this.queryEngineRequest.reportPackId || 0;
    this.queryModel.reportPackTitle =
      this.queryEngineRequest.reportPackTitle || "";
    this.selectedReportPack = this.normalizeSelectedReportPack(
      this.queryEngineRequest.selectedReportPack,
    );

    if (!this.selectedReportPack && this.queryModel.reportPackId > 0) {
      this.selectedReportPack = {
        ReportPackID: this.queryModel.reportPackId,
        Title: this.queryModel.reportPackTitle,
      };
    }

    if (this.selectedReportPack) {
      this.onReportPackSelection();
      this.queryModel.queryId = this.queryEngineRequest.queryId || 1;
      this.queryModel.auditReportDetailDesc =
        this.selectedReportPack.ReportPackID +
        "~" +
        this.queryEngineRequest?.reportTemplateList?.ReportId +
        "~" +
        this.queryEngineRequest?.reportTemplateList?.DisplayName +
        "~" +
        this.queryEngineRequest?.reportTemplateList?.Description +
        "~" +
        this.queryEngineRequest?.reportTemplateList?.ReportTemplateId +
        "~" +
        this.queryEngineRequest?.reportTemplateList?.ReportingType;
      this.queryModel.queryDisplayName =
        this.queryEngineRequest?.reportTemplateList?.DisplayName;
      this.queryModel.selectedGridDetailDescription =
        this.queryEngineRequest?.reportTemplateList?.Description;
      //  +
      // this.queryEngineRequest?.reportTemplateList?.Description;
    }

    this.getQueryResult(true, true);
    this.redirectfromReport = false;
  }

  private normalizeSelectedReportPack(selectedReportPack: any): any {
    if (Array.isArray(selectedReportPack)) {
      return selectedReportPack.length > 0 ? selectedReportPack[0] : null;
    }

    return selectedReportPack || null;
  }

  private filterReportTreeById(nodes: any[], reportId: any, parentDisplayName?: string): any[] {
    return nodes.reduce((filteredNodes: any[], node: any) => {
      var nodeCopy = JSON.parse(JSON.stringify(node));
      var childNodes = Array.isArray(nodeCopy.children)
        ? this.filterReportTreeById(nodeCopy.children, reportId, parentDisplayName)
        : [];
      var matchesReport = nodeCopy.data && nodeCopy.data.TemplateId == reportId;

      if (matchesReport || childNodes.length > 0) {
        nodeCopy.children = childNodes;
        if (parentDisplayName && !matchesReport) {
          const isDirectParentOfLeaf = (nodeCopy.children || []).some(
            (child: any) => child.data && child.data.TemplateId == reportId
          );
          nodeCopy.expanded = isDirectParentOfLeaf
            ? nodeCopy.data?.DisplayName === parentDisplayName
            : true;
        } else {
          nodeCopy.expanded = true;
        }
        filteredNodes.push(nodeCopy);
      }

      return filteredNodes;
    }, []);
  }

  // private filterReportTreeByDisplayName(
  //   nodes: any[],
  //   reportDisplayName: string,
  // ): any[] {
  //   return nodes.reduce((filteredNodes: any[], node: any) => {
  //     var nodeCopy = JSON.parse(JSON.stringify(node));
  //     var childNodes = Array.isArray(nodeCopy.children)
  //       ? this.filterReportTreeByDisplayName(nodeCopy.children, reportDisplayName)
  //       : [];
  //     var matchesReport =
  //       nodeCopy.data && nodeCopy.data.DisplayName === reportDisplayName;

  //     if (matchesReport || childNodes.length > 0) {
  //       nodeCopy.children = childNodes;
  //       nodeCopy.expanded = true;
  //       filteredNodes.push(nodeCopy);
  //     }

  //     return filteredNodes;
  //   }, []);
  // }

  private prepareReportingTypeOptions(reportingTypes: any) {
    this.reportingTypeOptions = [];
    reportingTypes.forEach((element) => {
      var option = {
        label: element.ReportingTypeName,
        value: element.ReportingTypeName,
      };
      this.reportingTypeOptions.push(option);
    });

    this.selectedReportingTypes = (
      this.reportingTypeOptions as Array<{
        value: string;
      }>
    )
      .map((option: { value: string }) => option.value)
      .filter((value: string) => this.defaultReportingTypes.includes(value));

    setTimeout(() => {
      if (this.dt && this.selectedReportingTypes.length > 0) {
        this.dt.filter(this.selectedReportingTypes, "ReportingType", "in");
      }
    }, 0);
  }

  clearFilters() {
    this.reportTreeListData = JSON.parse(JSON.stringify(this.treeList));
    this.selectedReportingTypes = [];
  }

  GetreportQueryResult(rowNode: any) {
    this.skip = 0;
    var parentData = rowNode.parent.data;
    this.queryModel.auditReportDetailDesc =
      this.selectedReportPack.ReportPackID +
      "~" +
      parentData.Id +
      "~" +
      rowNode.node.data.DisplayName +
      "~" +
      parentData.Alias +
      "~" +
      rowNode.node.data.TemplateId +
      "~" +
      rowNode.node.data.ReportingType;
    this.queryModel.queryDisplayName =
      parentData.Name + rowNode.node.data.DisplayName;
    this.queryModel.selectedGridDetailDescription =
      rowNode.node.data.Description;
    this.getQueryResult(true, true);
  }

  DownloadreportQueryResult(rowNode: any) {
    var parentData = rowNode.parent.data;
    this.queryModel.auditReportDetailDesc =
      this.selectedReportPack.ReportPackID +
      "~" +
      parentData.Id +
      "~" +
      rowNode.node.data.DisplayName +
      "~" +
      parentData.Alias +
      "~" +
      rowNode.node.data.TemplateId +
      "~" +
      rowNode.node.data.ReportingType;
    this.queryModel.queryDisplayName =
      parentData.Name + rowNode.node.data.DisplayName;
    this.queryModel.selectedGridDetailDescription =
      rowNode.node.data.Description;
    this.downloadQueryResult(this.queryModel);
  }

  saveUserQuery() {
    this.loading = true;
    this.queryModel.queryName = this.userQueryName;
    this.queryEngineService
      .saveUserDefinedQueries(this.queryModel)
      .then((model: any) => {
        this.alertService.info("Record Saved successfully!");
        this.loading = false;
        this.cdr.detectChanges();
        this.userQueryName = "";
      })
      .catch(() => {
        this.loading = false;
        this.cdr.detectChanges();
      });
  }

  getUserDefinedQueryList() {
    this.loading = true;
    this.queryEngineService
      .getUserDefinedQueries()
      .then((queryResult: any[]) => {
        this.userDefinedqueryList = queryResult.map((x) => ({
          queryTypeId: x.QueryTypeId,
          queryId: x.QueryId,
          // reportPackId: x.ReportPackId,
          auditReportDetailDesc: x.AuditReportDetailDesc,
          filter: x.Filter,
          sortList: x.SortList,
          userId: x.UserId,
          validFrom: x.ValidFrom,
          validTo: x.ValidTo,
          comments: x.Comments,
          queryName: x.QueryName,
          userDefinedQueryTypeId: x.UserDefinedQueryTypeId,
          userDefinedQueryDisplayName: x.QueryName,
          userDefinedQueryDescription: x.Comments || x.QueryDescription || "",
        }));

        this.loading = false;
        this.cdr.detectChanges();
      })
      .catch(() => {
        this.loading = false;
        this.cdr.detectChanges();
      });
  }
  onUserDefinedQueryTypeChange() {
    this.clearGridData();
    this.selectedQueryTypeId = this.queryModel.queryTypeId;
    if (this.queryModel.userDefinedQueryTypeId && this.userDefinedqueryList) {
      this.userDefinedQueryModel = this.userDefinedqueryList.find(
        (x) =>
          x.userDefinedQueryTypeId == this.queryModel.userDefinedQueryTypeId,
      );
      if (this.userDefinedQueryModel) {
        this.queryModel.queryId = this.userDefinedQueryModel.queryId;
        this.userQueryName =
          this.userDefinedQueryModel.userDefinedQueryDisplayName;
        this.queryModel.sortList = JSON.parse(
          this.userDefinedQueryModel.sortList,
        );
        this.queryModel.filter = JSON.parse(this.userDefinedQueryModel.filter);
        this.queryModel.auditReportDetailDesc =
          this.userDefinedQueryModel.auditReportDetailDesc;
        this.queryModel.queryDisplayName =
          this.userDefinedQueryModel.userDefinedQueryDisplayName;
      }
    }
  }

  preserveTreeScrollPosition() {
    const bodyElement = document.querySelector(
      ".table-irr .p-treetable-scrollable-body",
    ) as HTMLElement | null;

    if (!bodyElement) {
      return;
    }

    const currentScrollTop = bodyElement.scrollTop;
    setTimeout(() => {
      const updatedBodyElement = document.querySelector(
        ".table-irr .p-treetable-scrollable-body",
      ) as HTMLElement | null;
      if (updatedBodyElement) {
        updatedBodyElement.scrollTop = currentScrollTop;
      }
    }, 0);
  }
}
